import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface FCRPRommsProps {
  onBack: () => void;
}

export default function FCRPRomms({ onBack }: FCRPRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Financial Closing & Reporting Process" />;
}
